<template>
    <div class="aside">
        <ul>
            <li>
                <a href="#"  title="Salesforce"><img :src="picData[2]" alt="Salesforce" />
                  Sales<br>force</a>
            </li>
            <li class="consulting">
                <a href="#this" title="ソフトウェア開発"><span></span><span></span><span></span>
                    <img :src="picData[1]" class="img1" alt="ソフトウェア開発" />
                    <img :src="picData[3]" class="img2" alt="ソフトウェア開発" />開発
                </a>
            </li>
            <li>
                <a href="#"><img :src="picData[0]" alt="人材派遣" />派遣</a>
            </li>
        </ul>
    </div>
</template>
<script>

export default {
    data() {
        return {
            picData: [
                require('../../assets/images/057.png'),
                require('../../assets/images/059.png'),
                require('../../assets/images/060.png'),
                require('../../assets/images/061.png')
            ]
        }
    }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SlideBtn/SlideBtn.vue